<template>
  <div>
    <!-- 篩選 -->
    <div class="card filter-card">
      <div class="card-body">
        <div class="filter-toggle-icon" @click="toggleFilter">
          <i :class="filterVisible ? 'fa fa-times' : 'fa fa-search'"></i>
        </div>
        <div v-if="filterVisible">
          <div class="row input-row">
            <div class="col-md-3">
              <label for="transaction-ref">Transaction ref</label>
              <input type="text" id="transaction-ref" class="form-control" v-model="filters.transactionRef" />
            </div>
            <div class="col-md-3">
              <label for="terminal-id">Terminal ID</label>
              <input type="text" id="terminal-id" class="form-control" v-model="filters.terminalId" />
            </div>
            <div class="col-md-3">
              <label for="driver-id">Driver ID</label>
              <input type="text" id="driver-id" class="form-control" v-model="filters.driverId" />
            </div>
            <div class="col-md-3">
              <label for="card-last4">Card - last 4 digits</label>
              <input type="text" id="card-last4" class="form-control" v-model="filters.cardLast4" />
            </div>
            <div class="col-md-3">
              <label for="card-type">Card type</label>
              <select id="card-type" class="form-control" v-model="filters.cardType">
                <option value="">All</option>
                <option value="visa">Visa</option>
                <option value="mastercard">Mastercard</option>
              </select>
            </div>
            <div class="col-md-3">
              <label for="subgroup">Subgroup</label>
              <select id="subgroup" class="form-control" v-model="filters.subgroup">
                <option value="">All</option>
                <option v-for="item in subgroupStore.subgroups" :value="item.id" >{{ item.name }}</option>
              </select>
            </div>
            <div class="col-md-3">
              <label for="from-date">From</label>
              <Datepicker1 class="datepicker-here form-control" :format="format" v-model="filters.fromDate" data-language="en" :enable-time-picker="false" placeholder="Select date" />
            </div>
            <div class="col-md-3">
              <label for="to-date">To</label>
              <Datepicker1 class="datepicker-here form-control" :format="format" v-model="filters.toDate" data-language="en" :enable-time-picker="false" placeholder="Select date" />
            </div>
            <div class="col-md-12 d-flex justify-content-end mt-4">
              <button class="btn btn-reset" @click="resetFilters">Reset</button>
              <button class="btn btn-search" @click="search">Search</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <!-- DataTable -->
    <div class="card mt-4" v-if="paginatedData != ''">
      <div class="card-body">
        <div class="table-responsive signal-table">
          <table class="table table-hover">
            <thead>
              <tr>
                <th 
                  @click="sortTable('transaction_datetime')" 
                  :class="{'sortable col-transaction-date': true, 'active': filters.sort_by === 'transaction_datetime'}">
                  <span>Transaction date/time &nbsp;</span>
                  <i v-if="filters.sort_by === 'transaction_datetime' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'transaction_datetime' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('paid_by_taxi1')" 
                  :class="{'sortable col-paid-by-taxi1': true, 'active': filters.sort_by === 'paid_by_taxi1'}">
                  <span>Paid by taxi1 &nbsp;</span>
                  <i v-if="filters.sort_by === 'paid_by_taxi1' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'paid_by_taxi1' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th scope="col" class="col-driver-id">Driver ID</th>
                <th 
                  @click="sortTable('tid')" 
                  :class="{'sortable col-terminal': true, 'active': filters.sort_by === 'tid'}">
                  <span>Terminal &nbsp;</span>
                  <i v-if="filters.sort_by === 'tid' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'tid' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('rrn')" 
                  :class="{'sortable col-bank-reference': true, 'active': filters.sort_by === 'rrn'}">
                  <span>Bank reference &nbsp;</span>
                  <i v-if="filters.sort_by === 'rrn' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'rrn' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('plate')" 
                  :class="{'sortable col-plate': true, 'active': filters.sort_by === 'plate'}">
                  <span>Plate &nbsp;</span>
                  <i v-if="filters.sort_by === 'plate' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'plate' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('type')" 
                  :class="{'sortable col-type': true, 'active': filters.sort_by === 'type'}">
                  <span>Type &nbsp;</span>
                  <i v-if="filters.sort_by === 'type' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'type' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('mid')" 
                  :class="{'sortable col-mid': true, 'active': filters.sort_by === 'mid'}">
                  <span>MID &nbsp;</span>
                  <i v-if="filters.sort_by === 'mid' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'mid' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('card_type')" 
                  :class="{'sortable col-card-type': true, 'active': filters.sort_by === 'card_type'}">
                  <span>Card type &nbsp;</span>
                  <i v-if="filters.sort_by === 'card_type' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'card_type' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('card_last_4_digits')" 
                  :class="{'sortable col-card-4': true, 'active': filters.sort_by === 'card_last_4_digits'}">
                  <span>Card - last 4 digits &nbsp;</span>
                  <i v-if="filters.sort_by === 'card_last_4_digits' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'card_last_4_digits' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('approval_status')" 
                  :class="{'sortable col-appr-code': true, 'active': filters.sort_by === 'approval_status'}">
                  <span>Approval status &nbsp;</span>
                  <i v-if="filters.sort_by === 'approval_status' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'approval_status' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th scope="col" class="col-subgroup">Subgroup</th>
                <th 
                  @click="sortTable('driver_name')" 
                  :class="{'sortable col-assigned-driver': true, 'active': filters.sort_by === 'driver_name'}">
                  <span>Driver name &nbsp;</span>
                  <i v-if="filters.sort_by === 'driver_name' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'driver_name' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('payment_method')" 
                  :class="{'sortable col-payment-method': true, 'active': filters.sort_by === 'payment_method'}">
                  <span>Payment method &nbsp;</span>
                  <i v-if="filters.sort_by === 'payment_method' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'payment_method' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('commn_percent')" 
                  :class="{'sortable col-comm-pct': true, 'active': filters.sort_by === 'commn_percent'}">
                  <span>Comm'n % &nbsp;</span>
                  <i v-if="filters.sort_by === 'commn_percent' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'commn_percent' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('face_value')" 
                  :class="{'sortable col-face-value': true, 'active': filters.sort_by === 'face_value'}">
                  <span>Face value &nbsp;</span>
                  <i v-if="filters.sort_by === 'face_value' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'face_value' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('comm_amount')" 
                  :class="{'sortable col-comm-amount': true, 'active': filters.sort_by === 'comm_amount'}">
                  <span>Comm'n amount &nbsp;</span>
                  <i v-if="filters.sort_by === 'comm_amount' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'comm_amount' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('total_amount')" 
                  :class="{'sortable col-total-amount': true, 'active': filters.sort_by === 'total_amount'}">
                  <span>Total amount &nbsp;</span>
                  <i v-if="filters.sort_by === 'total_amount' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'total_amount' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
                <th 
                  @click="sortTable('service_fee')" 
                  :class="{'sortable col-service-fee': true, 'active': filters.sort_by === 'service_fee'}">
                  <span>Service fee &nbsp;</span>
                  <i v-if="filters.sort_by === 'service_fee' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                  <i v-if="filters.sort_by === 'service_fee' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in paginatedData" :key="index">
                <td>{{ item.transaction_date_time }}</td>
                <td>{{ item.paid_by_taxi1 }}</td>
                <td>{{ item.driver_id }}</td>
                <td>{{ item.terminal }}</td>
                <td>{{ item.rrn }}</td>
                <td>{{ item.plate }}</td>
                <td>{{ item.type }}</td>
                <td>{{ item.mid }}</td>
                <td>{{ item.card_type }}</td>
                <td>{{ item.card_last_4_digits }}</td>
                <td>
                  <i :class="item.approval_status === 'Approved' ? 'fa fa-check' : 'fa fa-times text-danger'"></i>
                </td>
                <td>{{ item.subgroup_name }}</td>
                <td>{{ item.driver_name }}</td>
                <td>{{ item.payment_method }}</td>
                <td>{{ item.commn_percent }}</td>
                <td>{{ formatCurrency(item.face_value) }}</td>
                <td>{{ formatCurrency(item.comm_amount) }}</td>
                <td>{{ formatCurrency(item.total_amount) }}</td>
                <td>{{ formatCurrency(item.service_fee) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
  
        <!-- 分頁 -->
        <div class="pagination-wrapper">
          <div class="pagination-container">
            <button @click="changePage(1)" :disabled="currentPage === 1"><img  src="@/assets/images/admin/arrow/prev-end.png" alt="Prev-end" style="width: 25px; height: 25px;" /></button>
            <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1"><img  src="@/assets/images/admin/arrow/prev.png" alt="Prev" style="width: 25px; height: 25px;" /></button>
            <span>
              Page
              <input type="number" style="width: 60px;" v-model.number="currentPageInput" @change="changePage(currentPageInput)" />
              of {{ totalPages }}
            </span>
            <button @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages"><img  src="@/assets/images/admin/arrow/next.png" alt="Next" style="width: 25px; height: 25px;" /></button>
            <button @click="changePage(totalPages)" :disabled="currentPage === totalPages"><img  src="@/assets/images/admin/arrow/next-end.png" alt="Next-end" style="width: 25px; height: 25px;" /></button>
          </div>
          <div class="total-count">
            Displaying transactions {{ (currentPage - 1) * itemsPerPage + 1 }} – {{ Math.min(currentPage * itemsPerPage, totalEntries) }} of {{ totalEntries }}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="no-results">No results found.</div>
  </div>
</template>
  
<script setup>
import { ref, computed, onMounted } from 'vue';
import Datepicker1 from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { useTransactionStore } from '@/store/admin/transaction';
import { useSubgroupStore } from '@/store/admin/subgroup';

// 格式化日期為 YYYY-MM-DD 格式的函數
const formatDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  const month = `${d.getMonth() + 1}`.padStart(2, '0');
  const day = `${d.getDate()}`.padStart(2, '0');
  const year = d.getFullYear();
  return `${year}-${month}-${day}`;
};

const format = (date) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

const transactionStore = useTransactionStore();
const subgroupStore = useSubgroupStore();

const filterVisible = ref(false); // 控制查詢器是否顯示，預設為收合狀態
const currentPage = ref(transactionStore.currentPage);
const itemsPerPage = ref(transactionStore.itemsPerPage);
const currentPageInput = ref(currentPage.value);

const filters = ref({
  transactionRef: '',
  terminalId: '',
  driverId: '',
  cardLast4: '',
  cardType: '',
  contract: '',
  subgroup: '',
  plateState: '',
  fromDate: '',
  toDate: '',
  sort_by:'transaction_datetime',
  order:'desc'
});

// 表格排序處理邏輯
const sortTable = (field) => {
  if (filters.value.sort_by === field) {
    filters.value.order = filters.value.order === 'asc' ? 'desc' : 'asc';
  } else {
    filters.value.sort_by = field;
    filters.value.order = 'desc';
  }
  const formattedFilters = {
    ...filters.value,
  };
  currentPage.value = 1; // 搜索时重置到第一页
  transactionStore.fetchTransactions(currentPage.value, itemsPerPage.value, formattedFilters);
};

const formatCurrency = (value) => {
    const absValue = Math.abs(value); // 取得絕對值並固定為兩位小數
    return value < 0 ? `-$${absValue}` : `$${absValue}`;
};

const toggleFilter = () => {
  filterVisible.value = !filterVisible.value;
};

const resetFilters = () => {
  filters.value = {
    transactionRef: '',
    terminalId: '',
    driverId: '',
    cardLast4: '',
    cardType: '',
    contract: '',
    subgroup: '',
    plateState: '',
    fromDate: '',
    toDate: '',
    sort_by:'transaction_datetime',
    order:'desc'
  };

  search();
};

const search = () => {
  filters.value.fromDate = formatDate(filters.value.fromDate);
  filters.value.toDate = formatDate(filters.value.toDate);
  currentPageInput.value = 1;
  currentPage.value = 1; // 搜索时重置到第一页
  transactionStore.fetchTransactions(currentPage.value, itemsPerPage.value, filters.value);
};

const paginatedData = computed(() => {
  return transactionStore.paginatedData;
});

const totalPages = computed(() => {
  return transactionStore.totalPages;
});

const totalEntries = computed(() => {
  return transactionStore.totalEntries;
});

const changePage = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
    currentPageInput.value = page;
    const formattedFilters = {
      ...filters.value,
      fromDate: formatDate(filters.value.fromDate),
      toDate: formatDate(filters.value.toDate),
    };
    transactionStore.fetchTransactions(page, itemsPerPage.value, formattedFilters);
  }
};

onMounted(() => {
  const formattedFilters = {
    ...filters.value,
    fromDate: formatDate(filters.value.fromDate),
    toDate: formatDate(filters.value.toDate),
  };
  changePage(1);
  transactionStore.fetchTransactions(currentPage.value, itemsPerPage.value, formattedFilters);
  subgroupStore.fetchSubgroups(1,9999);
});
</script>

  
  <style scoped>
  .card {
    margin: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .card-body {
    padding: 20px;
    position: relative;
  }

  .no-results {
    margin: 15px;
    border-radius: 20px;
    padding: 50px;
    font-size: 20px;
    text-align: center;
    color: black;
    background-color: #ccd3da;
  }
  
  .table-responsive {
    margin-top: 20px; 
  }
  
  .table-hover tbody tr:hover {
    background-color: #f1f1f1;
  }

  /* 為表格欄位設定最小寬度 */
  .col-transaction-date { min-width: 210px; }
  .col-paid-by-taxi1 { min-width: 150px; }
  .col-driver-id { min-width: 130px; }
  .col-terminal { min-width: 110px; }
  .col-bank-reference { min-width: 150px; }
  .col-plate { min-width: 100px; }
  .col-type { min-width: 100px; }
  .col-mid { min-width: 100px; }
  .col-card-4 { min-width: 180px; }
  .col-card-type { min-width: 120px; }
  .col-appr-code { min-width: 160px; }
  .col-subgroup { min-width: 130px; }
  .col-assigned-driver { min-width: 180px; }
  .col-payable-to { min-width: 250px; }
  .col-payment-method { min-width: 170px; }
  .col-comm-pct { min-width: 120px; }
  .col-face-value {min-width: 120px;}
  .col-comm-amount {min-width: 160px;}
  .col-total-amount { min-width: 150px; }
  .col-service-fee { min-width: 120px; }
  .col-rnn { min-width: 100px; }
  
  .table th.sortable {
  cursor: pointer;
  position: relative;
  padding-bottom: 10px;
}

.table th.sortable:hover {
  color: #00c962; /* Hover 時的文字顏色 */
}

.table th.active {
  color: #00c962; /* 當前排序的欄位文字顏色 */
}

/* 排序箭頭樣式 */
.sort-icon {
  width: 12px;
  height: 12px;
  margin-left: 5px;
  vertical-align: middle;
}

/* 排序欄位下的綠色下劃線 */
.table th.active::after {
  content: '';
  display: block;
  width: 100%;
  height: 2px;
  background-color: #00c962;
  position: absolute;
  bottom: 0;
  left: 0;
}

  .pagination-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 10px;
  }
  
  .pagination-container {
    display: flex;
    align-items: center;
  }
  
  .pagination-container button {
    border: none;
    background: none;
    cursor: pointer;
    font-size: 16px;
    color: #8476f4;
  }
  
  .pagination-container span {
    margin: 0 10px;
  }
  
  .pagination-container input {
    width: 30px;
    height: 30px;
    text-align: center;
  }
  
  .btn-reset {
    /* BTN_B */

    box-sizing: border-box;

    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 14px 32px;
    gap: 10px;

    width: 150px;
    height: 46px;

    /* Green */
    border: 2px solid #00C962;
    border-radius: 30px;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  .btn-search {
    /* BTN_A_V2 */

    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 32px;
    gap: 10px;

    width: 150px;
    height: 46px;

    /* Green */
    background: #00C962;
    border-radius: 30px;

    /* Inside auto layout */
    flex: none;
    order: 1;
    flex-grow: 0;
  }

  .btn-reset:hover {
    background: white;
    border: 2px solid #00b452;
  }
  .btn-search:hover {
    background: #00b452;
    border: 2px solid #00b452;
  }


  .btn-green {
    margin-top: 20px;
    background-color: #00c962;
    height: 40px;
  }

  
  
  .btn-green {
    margin-top: 20px;
    background-color: #00c962;
    height: 50px;
  }
  
  .btn-toggle {
    background: none;
    border: none;
    color: #8476f4;
    font-size: 24px;
    cursor: pointer;
  }

  .filter-toggle-icon{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 30px;
    color: #666;
    cursor: pointer;
  }
  
  .total-count {
    font-size: 16px;
    color: #666;
  }
  
  .toggle-filter {
    text-align: right;
    margin: 20px;
  }
  
  .filter-header {
    display: flex;
    justify-content: flex-end;
  }

  .signal-table.table-responsive .table tbody tr td:nth-child(n+2) {
    min-width: 100px !important;
  }

  @media (max-width: 630px) {
  .pagination-wrapper {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .pagination-summary {
    margin-top: 10px;
    justify-content: center;
  }

  .pagination-container {
    justify-content: center;
    width: 100%;
    margin-bottom: 10px;
  }
}
  </style>
  